import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Divider from "@mui/material/Divider";
import DatabasePicker from "../other/StartRunDatabasePicker";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    divider: css`
        margin: 10px 0;
    `,
};

const SelectServiceStatistics = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={classes.instruction}>2. {t("Select service statistics")}</div>

            <DatabasePicker
                variant="emu"
                databaseType={props.emuDatabaseType}
                customDatabases={[{ id: "", name: t("None") }, ...props.customEmuDatabases]}
                selectedDatabaseId={props.selectedEmuDatabaseId}
                uploadedDatabaseName={props.uploadedEmuDatabaseName}
                databaseUploadProgress={props.emuDatabaseUploadProgress}
                uploadingDatabase={props.uploadingEmuDatabase}
                onChangeDatabaseType={props.onChangeEmuDatabaseType}
                onSelectDatabase={props.onSelectEmuDatabase}
                onSelectDatabaseFile={props.onSelectEmuDatabaseFile}
                onUploadDatabase={props.onUploadEmuDatabase}
                onCancelDatabaseUpload={props.onCancelEmuDatabaseUpload}
            />

            <Divider className={classes.divider} />
        </div>
    );
};

export default SelectServiceStatistics;
